/**
 * SSR-safe interop for react-helmet-async.
 *
 * The package ships CJS; Vite's SSR module runner does not synthesize named
 * exports for it ("Named export 'HelmetProvider' not found"), while the
 * client build does. Resolving through the default export covers both.
 */
import * as HelmetNS from "react-helmet-async";

type NS = typeof HelmetNS;

const resolved: NS =
  ((HelmetNS as unknown as { default?: NS }).default ?? HelmetNS) as NS;

export const Helmet: NS["Helmet"] = resolved.Helmet;
export const HelmetProvider: NS["HelmetProvider"] = resolved.HelmetProvider;
